// Yardımcı fonksiyonlar burada olacak 

export const parseSignalRError = (err: any): string => {
  if (err && typeof err.message === 'string') {
    const hubExceptionPrefix = 'HubException: ';
    const message = err.message;

    const hubExceptionIndex = message.indexOf(hubExceptionPrefix);
    if (hubExceptionIndex !== -1) {
      return message.substring(hubExceptionIndex + hubExceptionPrefix.length);
    }

    // For other generic errors from SignalR
    const genericErrorPrefix = "Error: ";
    const genericErrorIndex = message.indexOf(genericErrorPrefix);
    if (genericErrorIndex !== -1) {
        return message.substring(genericErrorIndex + genericErrorPrefix.length);
    }

    return message; // Return original message if pattern not found
  }
  return 'An unknown error occurred.';
}; 